import { ScopeOfPracticeEnum } from '@umss/shared/utils';
import { FacilityClassification } from './../../enums/facility.enum';
import {
  FacilityDto,
  FacilityStatus
} from './../../models/facilities/facility.model';
export const mockFacility: FacilityDto = {
  id: '9c7a6d3e-8c2a-4b9c-9c94-3d5c7b8e4a21',
  name: 'Sunrise Medical Center',
  description:
    'Full-service medical facility specializing in long-term and acute care.',
  isActive: true,
  createdAt: '2024-08-12T14:32:10.000Z',
  updatedAt: '2025-01-20T09:15:45.000Z',

  facilityTypeId: 2,
  facilityTypeName: 'Hospital',
  facilityTypeHasSubtypes: true,

  classification: FacilityClassification.STANDARD,
  classificationDisplay: 'Medical Facility',

  status: FacilityStatus.Active,
  statusDisplay: 'Active',

  billingManagedByCorporate: false,

  location: {
    id: 101,
    addressLine1: '1234 Sunset Blvd',
    addressLine2: 'Suite 500',
    city: 'Los Angeles',
    stateCode: 'CA',
    stateName: 'California',
    zipCode: '90026',
    countryCode: 'US',
    latitude: 34.0775,
    longitude: -118.2606,
    fullAddress:
      '1234 Sunset Blvd, Suite 500, Los Angeles, CA 90026, United States'
  },

  contactPhone: '+1-323-555-8742',
  contactEmail: 'info@sunrisemedicalcenter.com',
  websiteUrl: 'https://www.sunrisemedicalcenter.com',

  onboardingCompleted: true,
  contractSignedDate: '2024-09-01',

  supportedScopes: [
    ScopeOfPracticeEnum.Rn,
    ScopeOfPracticeEnum.Lpn,
    ScopeOfPracticeEnum.Cna,
    ScopeOfPracticeEnum.Pt,
    ScopeOfPracticeEnum.Slp
  ],

  contacts: [
    {
      id: 1,
      contactType: 'Administrator',
      firstName: 'Emily',
      lastName: 'Johnson',
      fullName: 'Emily Johnson',
      title: 'Facility Administrator',
      email: 'emily.johnson@sunrisemedicalcenter.com',
      phone: '+1-323-555-1101',
      isPrimary: true
    },
    {
      id: 2,
      contactType: 'HR',
      firstName: 'Michael',
      lastName: 'Rodriguez',
      fullName: 'Michael Rodriguez',
      title: 'HR Manager',
      email: 'michael.rodriguez@sunrisemedicalcenter.com',
      phone: '+1-323-555-1102',
      isPrimary: false
    }
  ],

  distanceMiles: undefined,
  isFavorite: false
};
